export default __webpack_public_path__ + "static/media/baysel3.ae9ad5c3.png";